namespace TabAurous.Finance {
    export interface ServiceInwardTaxRow {
        TransTaxId?: number;
        TransId?: number;
        HSN?: string;
        ProductTypeId?: number;
        NetAmount?: number;
        TaxId?: number;
        TaxRate?: number;
        TaxAmount?: number;
        CCTaxAmount?: number;
        TaxType?: string;
        TaxName?: string;
        LedgerId?: number;
        OutputLedgerId?: number;
        InputRCMLedgerId?: number;
        OutputRCMLedgerId?: number;
        LedgerName?: string;
        PartyTax?: string;
        ECommGST?: string;
        ReverseCharge?: string;
        InvoiceType?: string;
        IntegratedTaxAmount?: number;
        CentralTaxAmount?: number;
        StateTaxAmount?: number;
        EligibilityForITC?: string;
        State?: string;
        B2CSType?: string;
    }

    export namespace ServiceInwardTaxRow {
        export const idProperty = 'TransTaxId';
        export const nameProperty = 'HSN';
        export const localTextPrefix = 'Finance.ServiceInwardTax';
        export const deletePermission = 'Finance:ServiceInward:Delete';
        export const insertPermission = 'Finance:ServiceInward:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:ServiceInward:Edit';

        export declare const enum Fields {
            TransTaxId = "TransTaxId",
            TransId = "TransId",
            HSN = "HSN",
            ProductTypeId = "ProductTypeId",
            NetAmount = "NetAmount",
            TaxId = "TaxId",
            TaxRate = "TaxRate",
            TaxAmount = "TaxAmount",
            CCTaxAmount = "CCTaxAmount",
            TaxType = "TaxType",
            TaxName = "TaxName",
            LedgerId = "LedgerId",
            OutputLedgerId = "OutputLedgerId",
            InputRCMLedgerId = "InputRCMLedgerId",
            OutputRCMLedgerId = "OutputRCMLedgerId",
            LedgerName = "LedgerName",
            PartyTax = "PartyTax",
            ECommGST = "ECommGST",
            ReverseCharge = "ReverseCharge",
            InvoiceType = "InvoiceType",
            IntegratedTaxAmount = "IntegratedTaxAmount",
            CentralTaxAmount = "CentralTaxAmount",
            StateTaxAmount = "StateTaxAmount",
            EligibilityForITC = "EligibilityForITC",
            State = "State",
            B2CSType = "B2CSType"
        }
    }
}
